function Info() {
  return (
    <svg
      width={40}
      height={40}
      viewBox="0 0 40 40"
      data-testid="info-icon"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.858 5.858c-7.81 7.81-7.81 20.474 0 28.284 7.81 7.81 20.474 7.81 28.284 0 7.81-7.81 7.81-20.475 0-28.284-7.81-7.81-20.475-7.81-28.284 0zM20.802 8.39c1.689 0 3.04 1.394 3.04 3.082 0 1.689-1.393 3.082-3.04 3.082-1.689 0-3.082-1.393-3.082-3.124 0-1.689 1.393-3.04 3.082-3.04zm4.348 20.644a2.02 2.02 0 01-.422.718c-1.097 1.14-2.448 1.815-4.053 1.815-.76 0-1.477 0-2.237-.126-1.224-.17-2.786-1.689-2.575-3.293l.506-3.293c.338-1.9.676-3.842 1.014-5.742 0-.126.042-.253.042-.38 0-.802-.253-1.097-1.056-1.181-.337-.043-.675-.085-1.013-.17-.38-.126-.59-.464-.549-.76.043-.337.254-.548.676-.633.21-.042.464-.042.718-.042H22.026c.718 0 1.14.338 1.14 1.056a8.47 8.47 0 01-.21 1.773c-.38 2.195-.803 4.348-1.183 6.543-.127.718-.295 1.436-.38 2.153-.042.338 0 .718.085 1.056.126.464.464.717.928.675.38-.042.76-.169 1.14-.338.296-.126.549-.337.845-.422.506-.169.886.127.76.591z"
        fill="#2C2C2C"
      />
    </svg>
  );
}

export default Info;
